import useVoyagerStore from '../../stores/useVoyagerStore';
import useStudioStore from '../../stores/useStudioStore';
import { setupTakes } from '../BuilderSetup/setupApi';
import { IntrospectionStage } from './api';

/** What the user sees while the cold-start pipeline advances. */
export const INTROSPECTION_STAGE_LABEL: Record<IntrospectionStage, string> = {
  '':         'Starting…',
  introspect: 'Introspecting schema…',
  mine:       'Mining query history…',
  profile:    'Profiling data…',
  propose:    'Proposing model…',
  draft:      'Drafting…',
  done:       'Done',
};

/** Bring one item of Studio's "Needs your review" panel (C3) into view once the review has loaded (#1174 §7). */
export function focusReviewItem(ref: string, tries = 20): void {
  if (!/^[0-9a-f]{64}$/.test(ref)) return;
  const found = document.querySelector(`[data-ref="${ref}"]`);
  if (found) { found.scrollIntoView({ block: 'center' }); return; }
  if (tries > 0) window.setTimeout(() => focusReviewItem(ref, tries - 1), 150);
}

/** Load a landed cold-start draft and jump to Studio for review; `reviewRef` names the item to bring into view. */
export const openDraftInStudio = async (draftId: string, reviewRef?: string) => {
  // Dynamic import mirrors navigationSlice.navigateToStudioWithContext — the
  // stores must not import each other statically.
  const { default: useStudioStore } = await import('../../stores/useStudioStore');
  // Studio's New source (#566) opens drafts from inside Studio, where the draft held may have unsaved edits.
  const { openDraftById } = await import('../Studio/openDraft');
  if (!await openDraftById(draftId)) return;
  // loadDraft swallows its own API errors into the Studio error state.
  // Navigate only if the REQUESTED draft actually loaded — landing the user
  // on whatever draft happened to be open would be worse than staying put.
  if (useStudioStore.getState().draftModel?.id !== draftId) {
    // eslint-disable-next-line no-console
    console.error(`Draft ${draftId} did not load:`, useStudioStore.getState().error);
    return;
  }
  useVoyagerStore.getState().navigateToStudio();
  if (reviewRef) focusReviewItem(reviewRef);
};

/** Build a semantic model on a warehouse: setup, on that warehouse; a provider setup can't take goes to Studio New source. */
export function buildModelOn(connection: { id: string; provider: string }): void {
  const voyager = useVoyagerStore.getState();
  if (setupTakes(connection.provider)) { voyager.navigateToSetupWith(connection.id); return; }
  useStudioStore.getState().setStudioHome('new-source');
  voyager.navigateToStudio();
}
